import React from 'react';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { createRoot } from 'react-dom/client';
import * as THREE from 'three'

const __origSetStyle = THREE.Color.prototype.setStyle

THREE.Color.prototype.setStyle = function (style) {
  if (typeof style === 'string') {
    // rgba(r,g,b,a) -> rgb(r,g,b)
    const m = style.match(
      /^rgba\(\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)\s*\)$/i
    )
    if (m) style = `rgb(${m[1]}, ${m[2]}, ${m[3]})`
  }
  return __origSetStyle.call(this, style)
}
const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);
